import React from 'react';

const WalkingIconSVG = ({ width, height }) => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={width} height={height} viewBox="0 0 64 64" style={{ fill: 'rgba(0, 0, 0, 1)', enableBackground: 'new 0 0 64 64' }}>
        <style>
            {`.st0{fill:#2C3177;}
              .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
              .st2{fill:#FFFFFF;}
              .st3{fill:none;stroke:#FFFFFF;stroke-width:1.4893;stroke-miterlimit:10;}
              .st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.2238;stroke-miterlimit:10;}`}
        </style>
        <path
            className="st0"
            d="M58.05,63.99H5.97c-3.24,0-5.89-2.65-5.89-5.89V5.92c0-3.24,2.65-5.89,5.89-5.89h52.07
            c3.24,0,5.89,2.65,5.89,5.89V58.1C63.93,61.34,61.28,63.99,58.05,63.99z"
        />
        <g>
            <g>
                <path
                    className="st2"
                    d="M49.71,53.95H16.4c-0.46,0-0.83-0.62-0.83-1.39s0.37-1.39,0.83-1.39h33.31c0.46,0,0.83,0.62,0.83,1.39
                    S50.17,53.95,49.71,53.95z"
                />
                <g>
                    <path
                        className="st2"
                        d="M39.93,45.34l-6.86-13.39c-0.34,2.02-0.97,3.96-1.81,5.73l4.88,9.6c0.38,0.72,1.09,1.14,1.89,1.14
                        c0.34,0,0.63-0.08,0.97-0.21C40.06,47.66,40.44,46.39,39.93,45.34z"
                    />
                    <circle className="st2" cx="28.69" cy="14.14" r="3.54" />
                    <path
                        className="st2"
                        d="M37.16,25.55c-3.87-1.64-6.4-5.81-6.44-5.9c-0.63-1.09-2.06-1.47-3.16-0.8c-0.17,0.08-0.29,0.21-0.42,0.29
                        C25.7,20.08,22,22.94,20.1,29.17c-0.38,1.18,0.29,2.44,1.52,2.82c1.18,0.38,2.44-0.29,2.82-1.52c0.8-2.65,1.98-4.51,3.03-5.68
                        c0.25,1.56,0.38,3.62,0,5.94c-1.18,7.24-7.87,13.81-7.96,13.9c-0.88,0.88-0.93,2.27-0.04,3.2c0.46,0.46,1.01,0.67,1.6,0.67
                        c0.55,0,1.14-0.21,1.56-0.63c0.34-0.29,7.92-7.71,9.22-16.38c0.21-1.22,0.25-2.4,0.29-3.5c0.97,0.72,2.02,1.35,3.2,1.85
                        c0.29,0.13,0.59,0.17,0.88,0.17c0.88,0,1.77-0.55,2.15-1.39C38.88,27.4,38.33,26.05,37.16,25.55z"
                    />
                </g>
            </g>
        </g>
    </svg>
);

export default WalkingIconSVG;
